import { useNavigate } from "react-router-dom";
import "./login.css"
import { useState, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import axios from "axios";
import { hasValues } from "../../utils/helperFunctions";

const Login = () => {

    const navigate = useNavigate()
    const  { loading, error, dispatch } = useContext(AuthContext)

    const [passwordType, setPasswordType] = useState("password");
    const [ credentials, setCredentials ] = useState({
        email: '',
        password: ''
    })

    const [login, setLogin] = useState({ loading: false, error: null })
    const handleChange = (e) => {
        setCredentials((prev) => ({ ...prev, [e.target.id]: e.target.value}));
    }

    const togglePassword = () => {
      if(passwordType === "password")
      {
       setPasswordType("text")
       return;
      }
      setPasswordType("password")
    }

    const handleLogin = async () => {
        //

        if(!hasValues(credentials)){
            setLogin((prev) => ({...prev, ['error']: 'Enter required fields'}))
            return;
        }

        //dispatch({type:"LOGIN_START"})

        setLogin((prev) => ({...prev, ['loading']: true}))

        try{
            const res = await axios.post("/auth/login", credentials);
            dispatch({ type: "LOGIN_SUCCESS", payload: res.data.details })
            navigate(-1)
        }catch(err){
            setLogin((prev) => ({...prev, ['loading']:false, ['error']: err.response.data.message}))
            return
        }
    }

  return (
    <div className="login">
        <div className="loginContainer">
            <div className="loginContainerHeader">
                <span className="accountLogin" onClick={(e) => navigate(-1)}>
                    <i class='bx bx-arrow-back'></i>
                    BACK
                </span>
                <span className="accountSpan" onClick={(e) => navigate('/register')}>CREATE ACCOUNT</span>
            </div>
            <div className="loginBody">
                <h3 className="app-title">Log into <span className="s1">Elation</span> <span className="s2">Cleaners</span></h3>
                <div className="loginBodyContainer">
                    <div className="loginBodyForm">
                        <div className="loginFormItem">
                            <p className="loginFormError">{ login.error? login.error : "" }</p>
                        </div>
                        <div className="loginFormItem">
                            <label>Email Address</label>
                            <input type="email" onChange={handleChange} id="email" placeholder="name@example.com" />
                        </div>
                        <div className="loginFormItem">
                            <label>Password</label>
                            <div className="passwordField">
                                <input type={passwordType} id="password" onChange={handleChange} name="password" placeholder="Password" />
                                <span>
                                    <i onClick={togglePassword} class={passwordType==="password"?"bx bx-show":"bx bx-hide"} ></i>
                                </span>
                            </div>
                        </div>
                        <div className={login.loading ? "loginFormItemBtn disabled":"loginFormItemBtn"} onClick={()=>handleLogin()}>
                            {login.loading ? "Logging in ..." : "Log In"}
                        </div>
                    </div>
                    <div className="loginBodyDivider">
                        <div className="vDivider"></div>
                        <span>OR</span>
                        <div className="vDivider"></div>
                    </div>
                    <div className="loginBodySocials">
                        <span className="loginSocialItem button-hover-effect bg-grey">
                            <img src="../../images/google-logo.png" className="google_logo" alt="Google Logo" />
                            <h5>Continue with Google</h5>
                        </span>
                        <span className="loginSocialItem button-hover-effect bg-grey">
                            <img src="../../images/apple-logo.png" className="apple_logo" alt="Apple Logo" />
                            <h5>Continue with Apple</h5>
                        </span>
                        <span className="loginSocialItem button-hover-effect bg-grey">
                            <img src="../../images/facebook-logo.png" className="facebook_logo" alt="Facebook Logo" />
                            <h5>Continue with Facebook</h5>
                        </span>
                    </div>
                </div>
                <div className="loginTextIssue">
                    <span>Can't Login?</span>
                </div>
                <div className="loginAppDesc">
                    <p>
                        By logging in, you agree to our <br />
                        Terms & Privacy
                    </p>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Login